import { Button, Flashbar, FlashbarProps } from '@amzn/awsui-components-core';
import React, { useEffect, useState } from 'react';
import { LoadingStatus } from './context/AppContextModels';
import { useAppContext } from './context/AppContextProvider';
import { sanitizeHtml } from 'src/utilities/SanitizeHtml';

export const DasFinSuiteApplicationBanner: React.FC = () => {
  const { homePageContent, contextLoadingStatus } = useAppContext();
  const [dismissed, setDismissed] = useState(false);

  // Reset dismissed state when banner config changes
  useEffect(() => {
    setDismissed(false);
  }, [homePageContent?.applicationBanner?.header, homePageContent?.applicationBanner?.content]);

  if (contextLoadingStatus !== LoadingStatus.Completed || !homePageContent?.applicationBanner?.isEnabled || dismissed) {
    return null;
  }

  const { applicationBanner } = homePageContent;

  const item: FlashbarProps.MessageDefinition = {
    type: applicationBanner.bannerType,
    header: applicationBanner.header,
    content: applicationBanner.content ? <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(applicationBanner.content) }} /> : undefined,
    dismissible: applicationBanner.dismissible,
    onDismiss: () => setDismissed(true),
    action: applicationBanner.action?.label ? (
      <Button href={applicationBanner.action.url} target="_blank" iconName="external" iconAlign="right">
        {applicationBanner.action.label}
      </Button>
    ) : undefined
  };

  return <Flashbar items={[item]} />;
};
